// extracted by mini-css-extract-plugin
export var container = "_6t-0";